import React, { memo } from 'react';

import { TaskBoard } from '../../_detailShared/TaskBoard';

interface ITasksTabProps {
  studentId: string;
}

/**
 * Student "Задачи" tab (spec 0003 redesign follow-up) — the shared bucketed
 * task board scoped to this student (across their agreements/groups): all
 * deadline buckets visible at once, with a due-date range + search and an
 * inline create form. Split out of the communication tab.
 */
export const TasksTab = memo(({ studentId }: ITasksTabProps) => (
  <TaskBoard studentId={studentId} showCreateForm />
));

TasksTab.displayName = 'TasksTab';
